// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"2c559784","498":"b6bd0d5e","820":"48e4c4a5"}[chunkId] + ".chunk.js";
};